function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Dots } from '../Loaders';
var Button = React.forwardRef(function (props, ref) {
  var children = props.children,
      className = props.className,
      type = props.type,
      disabled = props.disabled,
      busy = props.busy,
      outline = props.outline,
      full = props.full,
      size = props.size,
      appearance = props.appearance,
      onClick = props.onClick,
      additionalProps = props.additionalProps;
  var busyText = busy.length > 0 ? busy : null;
  var buttonDisabled = disabled || busy || busyText ? true : false;
  var buttonClass = classnames(className, {
    'bg-primary-500 hover:bg-primary-600': type === 'primary' && !outline && !buttonDisabled && appearance === 'light',
    'bg-secondary-500 hover:bg-secondary-600': type === 'secondary' && !outline && !buttonDisabled && appearance === 'light',
    'bg-neutral-900': type !== 'primary' && type !== 'secondary' && !outline && !buttonDisabled && appearance === 'light',
    'bc-primary-500 hover:bc-primary-600 c-primary-500 hover:c-primary-600': type === 'primary' && outline && !buttonDisabled,
    'bc-secondary-500 hover:bc-secondary-600 c-secondary-500 hover:c-secondary-600': type === 'secondary' && outline && !buttonDisabled,
    'bc-neutral-900 c-neutral-900': type !== 'primary' && type !== 'secondary' && outline && !buttonDisabled,
    'bg-white hover:bg-white c-primary-500': type === 'primary' && !outline && !buttonDisabled && appearance === 'dark',
    'bg-white hover:bg-white c-secondary-500': type === 'secondary' && !outline && !buttonDisabled && appearance === 'dark',
    'c-neutral-900 bg-white hover:bg-white': type !== 'primary' && type !== 'secondary' && !outline && !buttonDisabled && appearance === 'dark',
    'bc-neutral-100 c-neutral-100': buttonDisabled && outline && appearance === 'light',
    'bg-neutral-100 c-white hover:bg-neutral-100': buttonDisabled && !outline && appearance === 'light',
    'bc-neutral-600 c-neutral-600': buttonDisabled && outline && appearance === 'dark',
    'bg-neutral-600 c-neutral-300 hover:bg-neutral-600': buttonDisabled && !outline && appearance === 'dark',
    'c-white bc-transparent': !outline,
    'bg-transparent': outline,
    'c-pointer': !disabled & !busy,
    'c-not-allowed': disabled & !busy,
    'c-wait': busy,
    'w-100p': full,
    'py-2 px-5 h-10 fs-4': size === 'lg',
    'py-2 px-4 h-9 fs-4': size === 'md',
    'py-1 px-3 h-8 fs-3': size === 'sm'
  }, 'fw-600 t-all', 'button', 'bs-solid', 'tp-color', 'td-500', 'bw-1', 'br-4', 'lh-solid', 'box-border');

  var handleClick = function handleClick(event) {
    event.preventDefault();
    if (disabled || busy) return;
    onClick(event);
  };

  var dotsColorConfig = '';
  if (appearance === 'light') dotsColorConfig = '#999';else dotsColorConfig = '#ccc';
  return React.createElement("button", _extends({
    ref: ref,
    className: buttonClass,
    onClick: handleClick
  }, additionalProps), busy && busyText && busyText, busy && !busyText && React.createElement(Dots, {
    className: "nmx-1",
    size: 8,
    color: dotsColorConfig
  }), !busy && children);
});
Button.propTypes = {
  /**
   * Additional classes to be added to the component
   */
  className: PropTypes.string,

  /**
   * Changes the appearance of the component
   */
  type: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * These values modify the size of the component
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),

  /**
   * This disables the button
   */
  disabled: PropTypes.bool,

  /**
   * This disables the button and shows a custom text
   */
  busy: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),

  /**
   * Changes the appearance to an outline
   */
  outline: PropTypes.bool,

  /**
   * Changes the appearance to dark/light mode
   */
  appearance: PropTypes.oneOf(['dark', 'light']),

  /**
   * Makes the button full width
   */
  full: PropTypes.bool,

  /**
   * Handles onclick function
   */
  onClick: PropTypes.func
};
Button.defaultProps = {
  className: '',
  type: 'primary',
  size: 'md',
  busy: false,
  disabled: false,
  appearance: 'light',
  outline: false,
  full: false,
  onClick: function onClick() {}
};
Button.displayName = 'Button';
export { Button };